import { FirearmType } from '@/model/firearm-type.mjs';
import { fixTimezoneOffset } from '@/queue/utils';
import { ValueFormatterParams } from 'ag-grid-community';
import moment from 'moment';

export function dateFormatterInboundDate({ data }: ValueFormatterParams) {
  const date = data?.inboundTransferCompletionTime
  return date && date !== null ? moment(date).local().format('MM/DD/YYYY') : '';
}

export function dateFormatter({ data }: ValueFormatterParams) {
  const date = data?.createdAt || data?.created_date_time || data?.created_at
  return date ? moment(date).local().format('MM/DD/YYYY') : '';
}

export function dateFormatteArchiveDate({ data }: ValueFormatterParams) {
  const date = data ? data["archiveDate"] : null
  return date ? moment(date).local().format('MM/DD/YYYY') : '';
}

export function getFormattedDateTime(date: number | null | Date | string) {
  if (date) {
    return moment(date).format('MM/DD/YYYY hh:mm A');
  }
}


export function getFormattedDateTimeV2(date: number | null | Date | string) {
  if (date) {
    return moment(date).format('MM-DD-YYYY [at] hh:mm A');
  }
}

export function getFormattedDate(date: string | null | Date | number, months: number = 0) {
  if (date && months) {
    return moment(date).add(months, 'months').format('MM/DD/YYYY');
  } else if (date) {
    return moment(date).format('MM/DD/YYYY');
  }
}

export function getFormattedTime(date: string | null | Date | number) {
  if (date) {
    return moment(date).format('HH:mm A'); // Formats time as '12:30 PM'
  }
  return ''; // Return empty string if no date is provided
}

export function dateFormatterInMonth(date: any) {
  return date ? moment(date).format('MMM D, YYYY hh:mm A') : '';
}
export const convertISTtoUTCDate = (date: string) => {
  if(date){
    const localDate = new Date(date);
    
    // Array of month abbreviations
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 
                    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    
    // Get UTC components
    const month = months[localDate.getUTCMonth()];
    const day = localDate.getUTCDate();
    const year = localDate.getUTCFullYear();
    
    // Return formatted string
    return `${month} ${day}, ${year}`;
  }
  return "";
}

export function getFormattedFirearm({ data }: ValueFormatterParams) {
  return formattedFirearm(data ? data.firearm : "")
}

export function formattedFirearm(firearm: string) {
  if (firearm) {
    switch (firearm) {
      case 'Pistol':
        return FirearmType.Pistol

      case 'Rifle':
        return FirearmType.Rifle

      case 'MultipleFirearmTypes':
        return FirearmType.MultipleFirearmTypes

      case 'NFASuppressor':
        return FirearmType.NFASuppressor

      default:
        return FirearmType.SBR
    }
  }
  return ''
}

export function getFormattedDateTimeFromCreatedAt({ data }: ValueFormatterParams) {
  const date = data?.createdAt || data?.created_date_time || data?.created_at
  if (date) {
    return getFormattedDateTime(date) as string
  }
  return ''
}

export function getFormattedDateTimeFromReviewedAt({ data }: ValueFormatterParams) {
  const date = data?.reviewed_at ? data?.reviewed_at : null
  if (date) {
    return getFormattedDateTime(date) as string
  }
  return ''
}

export function getFormattedDateTimeFroManualReviewedAt({ data }: ValueFormatterParams) {
  const date = data?.manual_review_requested_at ? data?.manual_review_requested_at : null
  if (date) {
    return getFormattedDateTime(date) as string
  }
  return ''
}

export function formatMinutes(minutes: number) {
  const duration = moment.duration(minutes, 'minutes');

  const days = Math.floor(duration.asDays());
  const hours = Math.floor(duration.asHours()) % 24;
  const mins = Math.floor(duration.asMinutes()) % 60;
  const secs = Math.floor(duration.asSeconds()) % 60;

  let result = '';

  if (days > 0) result += `${days}d `;
  if (hours > 0) result += `${hours}h `;
  if (mins > 0) result += `${mins}m `;
  if (secs > 0) result += `${secs}s`;

  return result.trim();
}

export const getDateTimeForAddresses = (date: string | undefined) => {
  if (date) {
    return moment(date).local().format('MM/DD/YYYY hh:mm A');
  }
  return null;
};